// extracted by mini-css-extract-plugin
export default {"lineBreak":"LineBreak_lineBreak__90kM4"};